/**
 * Datos de navegación y configuración del sitio
 */

/**
 * Enlaces de navegación principal
 */
export const navLinks = [
  {
    id: 1,
    label: 'Inicio',
    labelKey: 'nav.home',
    url: '/',
  },
  {
    id: 2,
    label: 'Quiénes Somos',
    labelKey: 'nav.about',
    url: '/nosotros',
  },
  {
    id: 3,
    label: 'Productos',
    labelKey: 'nav.products',
    url: '/productos',
  },
  {
    id: 4,
    label: 'Recetas',
    labelKey: 'nav.recipes',
    url: '/recetas',
  },
  {
    id: 5,
    label: 'Noticias',
    labelKey: 'nav.news',
    url: '/noticias',
  },
  {
    id: 6,
    label: 'Portal de transparencia',
    labelKey: 'nav.transparency',
    url: '/transparencia',
  },
  {
    id: 7,
    label: 'Contacto',
    labelKey: 'nav.contact',
    url: '/contacto',
  },
];

/**
 * Enlaces de redes sociales
 */
export const socialLinks = [
  {
    id: 1,
    name: 'Facebook',
    url: 'https://www.facebook.com/IntercasaCanarias',
    icon: 'facebook',
  },
  {
    id: 2,
    name: 'X',
    url: 'https://x.com/IntercasaCan',
    icon: 'x',
  },
  {
    id: 3,
    name: 'YouTube',
    url: 'https://www.youtube.com/user/IntercasaCanarias',
    icon: 'youtube',
  },
  {
    id: 4,
    name: 'Instagram',
    url: 'https://www.instagram.com/intercasacanarias/',
    icon: 'instagram',
  },
  {
    id: 5,
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/intercasa-s-a-',
    icon: 'linkedin',
  },
];

/**
 * Enlaces legales del footer
 */
export const legalLinks = [
  {
    id: 1,
    label: 'Subvenciones',
    labelKey: 'footer.legal.subsidies',
    url: '/transparencia/ayudas',
  },
  {
    id: 2,
    label: 'Aviso Legal',
    labelKey: 'footer.legal.legalNotice',
    url: '/aviso',
  },
  {
    id: 3,
    label: 'Política de Cookies',
    labelKey: 'footer.legal.cookies',
    url: '/cookies',
  },
  {
    id: 4,
    label: 'Política de Privacidad',
    labelKey: 'footer.legal.privacy',
    url: '/privacidad',
  },
];

/**
 * Enlace del sello "Elaborado en Canarias"
 */
export const elaboradoEnCanariasLink = {
  url: 'https://elaboradoencanarias.com/brands/intercasa/',
  imageUrl: '/images/footer/elaborado-en-canarias.webp',
  // Sello oficial de calidad regional: el nombre "Elaborado en Canarias" no se traduce
  alt: {
    es: 'Elaborado en Canarias',
    en: '"Elaborado en Canarias" seal (Made in the Canary Islands)',
    fr: 'Sceau «\u00a0Elaborado en Canarias\u00a0» (produit aux Canaries)',
    pt: 'Selo «Elaborado en Canarias» (produzido nas Canárias)',
  },
};
